import api from "./api";

export type TillsId = {
  id: number | string;
};

export interface Denomination {
  id: number;
  curr: {
    id: number;
    name: string;
    symbol: string;
    abbreviation: string;
  };
  denomination: number;
  isActive: boolean;
}

export const getTillStats = async (id: number) => {
  return await api.get(`/tills/${id}/stats`);
};

// export const getTillProductStats = async (id: number) => {
//   return await api.get(`/tills/${id}/productStats`);
// };


export const getTillProductStats = async (Dto: {
  tillId: number;
  limit?: number;
  offset?: number;
}) => {
  // Construct the query string
  const queryParams: Record<string, string> = {};

  if (Dto.limit) {
      queryParams.limit = Dto.limit.toString();
  }

  if (Dto.offset) {
      queryParams.offset = Dto.offset.toString();
  }

  if (Dto.tillId) {
      queryParams.tillId = Dto.tillId.toString();
  }

  const queryString = Object.keys(queryParams)
      .map(key => `${key}=${queryParams[key]}`)
      .join('&');

  // Construct the API request URL with the query string
  const url = `/tills/${Dto.tillId}/productStats/${queryString ? `?${queryString}` : ''}`;

  return await api.get(url);
};

export const getCurrencyDenomination = async () => {
  return await api.get(`/currencyDenomination`);
};
